import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetRegions from './queries/useGetRegions';

import { Button } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from 'hooks/useColumnState';

import { getRegionsTableColumns } from './regionsTableConfig';

export default function RegionsList() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditRegion = useCallback(
        (regionData) => {
            navigate(`/regions-and-locations/regions/edit/${regionData.id}`);
        },
        [navigate],
    );

    const handleAddRegion = () => {
        navigate('/regions-and-locations/regions/add');
    };

    const baseColumns = useMemo(
        () =>
            getRegionsTableColumns({
                darkMode,
                onEditRegion: handleEditRegion,
            }),
        [darkMode, handleEditRegion],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetRegions(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    return (
        <AGGridMain
            gridRef={gridRef}
            tableData={tableDataWithColumns}
            isLoading={isFetchingData}
            titleName="Regions"
            refetch={refetch}
            onColumnVisible={onColumnVisible}
            overlayNoRowsTemplate="No Regions Found"
            extraComponents={
                <HStack pl={5} spacing={2}>
                    <Button
                        leftIcon={<AddIcon />}
                        onClick={handleAddRegion}
                        size="sm"
                        padding="6px 12px">
                        Add Region
                    </Button>
                </HStack>
            }
        />
    );
}
